// src/store/reducers/userReducer.js
import { SET_TIME } from "../Actions/timeActions";

const initialState = {
  time: null,
};

const TimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIME:
      return {
        ...state,
        time: action.payload,
      };
    default:
      return state;
  }
};

export default TimeReducer;
